import qs from 'qs';
import { axiosAuthInterceptor } from "./axiosInterceptors"

const API_ADDRESS = process.env.REACT_APP_MAIN_API_ADDRESS;

const erpItemDataConnect = () => {
    return {
        /**
         * 
         * @param {object} params 
         * @param {string} params.salesYn
         * @param {string} params.releaseYn
         * @param {string} params.periodSearchCondition
         * @param {string} params.startDateTime
         * @param {string} params.endDateTime
         * @param {string} params.mpSearchCondition
         * @param {string} params.mpSearchQuery
         * @param {string} params.oiSearchCondition
         * @param {string} params.oiSearchQuery
         * @param {string} params.riSearchCondition
         * @param {string} params.riSearchQuery
         * @param {string} params.diSearchCondition
         * @param {string} params.diSearchQuery
         * @param {string} params.matchedCode
         * 
         * @param {object} headers
         * @param {string} headers.wsId
         * @returns 
         */
        count: async function (headers, params) {
            return await axiosAuthInterceptor.get(`${API_ADDRESS}/api/v1/erp-items/count`, {
                headers: headers,
                params: params,
                withCredentials: true,
                xsrfCookieName: 'x_api_csrf_token',
                xsrfHeaderName: 'X-XSRF-TOKEN',
                paramsSerializer: params => {
                    return qs.stringify(params, { arrayFormat: 'brackets' })
                }
            })
        },
    }
}

export {
    erpItemDataConnect
}